<template>
    <div> <!-- Element rădăcină -->
      <!--General Top Bar -->
      <!-- <general-top-bar :title="$t('pages.dashboard')"></general-top-bar> -->
      <!--End General Top Bar -->
      <p style="margin: 20px 0; font-size: 16px;">
        Urmează un dashboard cu mai multe rapoarte, pentru a putea vizualiza informațiile importante într-un singur loc.
      </p>
     </div>
</template>

  <script>
    // import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'
    export default {
      components: {
        // GeneralTopBar
      },
      data () {
        return { }
      },
      methods: { }
    }
  </script>

<style scoped>
.box-inline {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  padding: 10px;
}

.item {
  padding: 5px 10px;
  background-color: white; /* Fundal alb pentru fiecare element */
  border: 1px solid transparent; /* Bordură inițial transparentă */
  border-radius: 3px;
  transition: border 0.3s; /* Tranziție pentru bordură */
}

/* Bordurile și culorile pentru text */
.item:nth-child(1) {
  border-color: green; /* Verde */
  color: green; /* Culoarea textului */
}

.item:nth-child(2) {
  border-color: lightblue; /* Albastru deschis */
  color: lightblue; /* Culoarea textului */
}

.item:nth-child(3),
.item:nth-child(4) {
  border-color: red; /* Roșu */
  color: red; /* Culoarea textului */
}

.item:nth-child(5),
.item:nth-child(6) {
  border-color: yellow; /* Galben */
  color: yellow; /* Culoarea textului */
}

.item:nth-child(7) {
  border-color: purple; /* Mov */
  color: purple; /* Culoarea textului */
}

.item:nth-child(8),
.item:nth-child(9) {
  border-color: darkblue; /* Albastru mai închis */
  color: darkblue; /* Culoarea textului */
}

.item:nth-child(10) {
  border-color: orange; /* Portocaliu */
  color: orange; /* Culoarea textului */
}

.item:nth-child(11),
.item:nth-child(12) {
  border-color: gray; /* Gri */
  color: gray; /* Culoarea textului */
}

/* Efect de hover */
.item:hover {
  filter: brightness(95%); /* Întunecă ușor la hover */
}
.item-marfa {
  color: blue; /* Text albastru pentru marfă */
  border: 1px solid blue; /* Border albastru */
  padding: 5px; /* Padding pentru a face elementul să arate bine */
  border-radius: 3px; /* Colțuri rotunjite */
}

.item-materie-prima {
  color: purple; /* Text mov pentru materie prima */
  border: 1px solid purple; /* Border mov */
  padding: 5px;
  border-radius: 3px;
}
.div-intrare {
  background-color: blue; /* Fundal albastru */
  color: white; /* Text alb */
  padding: 5px; /* Padding pentru a face elementul să arate bine */
  border-radius: 3px; /* Colțuri rotunjite */
  text-align: center; /* Centrarea textului */
}

.div-resetare {
  background-color: red; /* Fundal roșu */
  color: white; /* Text alb */
  padding: 5px; /* Padding pentru a face elementul să arate bine */
  border-radius: 3px; /* Colțuri rotunjite */
  text-align: center; /* Centrarea textului */
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Management/Dashboard/ManagementDashboard.vue